import $ from 'jquery'

export class ChapterManager {

	/**
	 * Current chapter being displayed on screen
	 */
	private currentChapterIndx: number;
	public get currentChapter(): Chapter {
		return this.chapters[this.currentChapterIndx];
	}

	private chapters: Chapter[] = [];
	public isLoaded: boolean;

	public setChapter(chapterId: string) {
		this.currentChapterIndx = -1;
		for(let indx = 0; indx < this.chapters.length; indx++) {
			if(this.chapters[indx].title === chapterId) {
				this.currentChapterIndx = indx;
				break;
			}
		}
		if(this.currentChapterIndx === -1) {
			console.warn('Could not find chapter with id ' + chapterId)
			// throw Error();
		}
	}

	public loadSrt(path: string): void {
		let context = this;
		// var xmlhttp = new XMLHttpRequest();
		// var url = path;

		// xmlhttp.onreadystatechange = function() {
		// 	console.log('this is the respinse text');
		// 	if (this.readyState == 4 && this.status == 200) {
		// 		console.log(this.responseText);
		// 		var result = JSON.parse(this.responseText);
		// 		context._strToObject(result).then((r: Chapter[]) => {
		// 			context.chapters = r;
		// 			context.currentChapterIndx = 0;
		// 			context.isLoaded = true;
		// 		});
		// 	}
		// };
		// xmlhttp.open("GET", url, true);
		// xmlhttp.send();
		$.get(path).then((result) => {
			context._strToObject(result).then((r: Chapter[]) => {
				this.chapters = r;
				this.currentChapterIndx = 0;
				context.isLoaded = true;
			});
		});
	}
	private _strToObject(str: string): any {
		return new Promise((resolve, reject) => {
			let result: Chapter[] = [];
			let lines: string[] = str.split('\n');
			
			enum lineType {
				id = 0,
				time = 1,
				title = 2
			}

			let currentLineType = lineType.id;
			let currChapter: Chapter = {};

			for(let lineIndx = 0; lineIndx < lines.length; lineIndx++) {
				let currentLine = lines[lineIndx].replace('\\r', '').trim();

				if(currentLine === '' || currentLine.startsWith('{/*')) {
					continue;
				}

				switch(currentLineType) {
					case lineType.id:
						currChapter.id = this.parseId(currentLine);
						break;
					case lineType.time:
						let time = this.parseTime(currentLine);
						currChapter.start = time.start;
						currChapter.end = time.end;
						break;
					case lineType.title:
						currChapter.title = this.parseTitle(currentLine);
						break;
				}

				currentLineType++;

				if(currentLineType > lineType.title) {
					result.push(currChapter);
					currChapter = {};
					currentLineType = lineType.id;
				}
			}

			resolve(result);
		});
	}

	private parseId(line: string): string {
		return line;
	}

	private parseTime(line: string): {start: number, end: number} {
		let onParseTime = (timeStr: string) => {
			let splitTime = timeStr.split(':');
			if(splitTime.length < 3) {
				console.error('invalid time. Here\' what was provided: ' + timeStr);
				return undefined;
			}
			let secondAndMillisecondSplit = splitTime[2].split(',');

			let hours = parseInt(splitTime[0]);
			let minutes = parseInt(splitTime[1]);
			let seconds = parseInt(secondAndMillisecondSplit[0]);
			let milliseconds = parseInt(secondAndMillisecondSplit[1]);

			let totalTimeInSeconds = 0;

			totalTimeInSeconds += (hours * 3600);
			totalTimeInSeconds += (minutes * 60);
			totalTimeInSeconds += seconds;
			totalTimeInSeconds += milliseconds / 1000;

			return totalTimeInSeconds;
		};

		let startEndTimeSplit = line.split('-->');

		if(startEndTimeSplit.length < 2) {
			return {
				start: 0,
				end: 0
			};
		}

		return {
			start: onParseTime(startEndTimeSplit[0].trim()),
			end: onParseTime(startEndTimeSplit[1].trim())
		}
	}

	private parseTitle(line: string): string {
		return line;
	}
}

export interface Chapter {
	id?: string;
	start?: number;
	end?: number;
	title?: string;
}